<template>
    <span class="govuk-caption-xl" id="page-heading-anchor">Service</span>
    <h1 class="govuk-heading-xl">Search probate records or find a will</h1>
</template>
